var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuIconWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 3.5,
    height: 16,
    viewBox: "0 0 3.5 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1.75,3.5A1.826,1.826,0,0,1,.5,2.975,1.741,1.741,0,0,1,0,1.75,1.973,1.973,0,0,1,.5.5,1.757,1.757,0,0,1,1.75,0,1.856,1.856,0,0,1,2.975.5,1.78,1.78,0,0,1,3.5,1.75,1.794,1.794,0,0,1,1.75,3.5Zm7.475-.525A1.767,1.767,0,0,0,9.75,1.75,1.874,1.874,0,0,0,9.225.5,1.741,1.741,0,0,0,8,0,1.92,1.92,0,0,0,6.75.5a1.757,1.757,0,0,0-.5,1.25,1.856,1.856,0,0,0,.5,1.225,1.721,1.721,0,0,0,2.475,0Zm6.25,0A1.767,1.767,0,0,0,16,1.75,1.874,1.874,0,0,0,15.475.5,1.741,1.741,0,0,0,14.25,0,1.92,1.92,0,0,0,13,.5a1.757,1.757,0,0,0-.5,1.25A1.856,1.856,0,0,0,13,2.975a1.721,1.721,0,0,0,2.475,0Z",
    transform: "translate(3.5) rotate(90)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIconWhite);
export default __webpack_public_path__ + "static/media/menu-icon-white.a1e9d840ce37fa2c65cc2e8306949de0.svg";
export { ForwardRef as ReactComponent };